import { type AxiosResponse } from 'axios'
import type { AxiosOptions } from 'shared/api'
import { baseApi } from 'entities/Auth'
import { BaseAnalyticsApi } from './baseAnalyticsApi'
import type {
  IConversionStatisticResponse,
  IConversionChartResponse,
  IConversionListParams,
  IConversionListResponse,
  IConversionDetailAnalyticsResponse,
  IAnalyticsParams,
  IAnalyticsExportParams,
  IAnalyticsExportResponse,
} from './types'

class ConversionsApi extends BaseAnalyticsApi<
  IConversionStatisticResponse,
  IConversionChartResponse
> {
  constructor() {
    super('conversions', 'core')
  }

  getConversions = (
    params: IConversionListParams,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IConversionListResponse>> => {
    return baseApi.get('core/analytics/conversions/list', {
      params,
      ...options,
    })
  }

  getConversionAnalytics = (
    id: number,
    params: IAnalyticsParams,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IConversionDetailAnalyticsResponse>> => {
    return baseApi.get(`analytics/analytics/conversions/${id}/chart`, {
      params,
      ...options,
    })
  }

  exportAnalyticsByConversionId = (
    id: number,
    params: IAnalyticsExportParams,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IAnalyticsExportResponse>> => {
    return baseApi.get(`core/analytics/conversions/${id}/export`, {
      params,
      ...options,
    })
  }
}

export const ConversionsAnalyticsApi = new ConversionsApi()
